import { render, staticRenderFns } from "./FanReward.vue?vue&type=template&id=02801ad6&"
import script from "./FanReward.vue?vue&type=script&lang=js&"
export * from "./FanReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports